export const getCroppedImg = async (
  imageSrc: string,
  pixelCrop: { x: number; y: number; width: number; height: number },
  outputSize: { width: number; height: number },
  isCircle = false,
): Promise<HTMLCanvasElement> => {
  const image = new Image();
  image.src = imageSrc;

  await new Promise((resolve) => {
    image.onload = resolve;
  });

  const canvas = document.createElement("canvas");
  canvas.width = outputSize.width;
  canvas.height = outputSize.height;
  const ctx = canvas.getContext("2d");

  if (!ctx) throw new Error("Could not get canvas context");

  ctx.imageSmoothingQuality = "high";

  if (isCircle) {
    ctx.beginPath();
    ctx.arc(
      outputSize.width / 2,
      outputSize.height / 2,
      Math.min(outputSize.width, outputSize.height) / 2,
      0,
      2 * Math.PI,
    );
    ctx.closePath();
    ctx.clip();
  }

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    outputSize.width,
    outputSize.height,
  );

  return canvas;
};
